// The Send volume tab's URL vocabulary. The routes' search validation reads it, and that code
// loads with the app shell, so this module must not import the tab's chart helpers.

export type SendVolumeType = 'all' | 'newsletters' | 'api_triggered';

export const SEND_VOLUME_TYPES: readonly { value: SendVolumeType; label: string }[] = [
  { value: 'all', label: 'All broadcast types' },
  { value: 'newsletters', label: 'One-time sends' },
  { value: 'api_triggered', label: 'API-triggered broadcasts' },
];

/** The broadcast type a URL value names, or `undefined` for anything else. */
export function parseSendVolumeType(value: unknown): SendVolumeType | undefined {
  return SEND_VOLUME_TYPES.find((type) => type.value === value)?.value;
}
